import {
    graphql
} from 'react-relay'






const query = graphql`
    query getInvoiceSupplierQuery($id: String!) {
        getInvoiceSupplier (id: $id){
            id
            title
            description
            address,
            date
            num
            tax
            postStamp
            discountType
            discountValue
            total
            totalTTC
            currencyId
            supplierId
            createdAt
            updatedAt
            deletedAt
            currency {id, name, code}
            supplier {id, name}
            invoiceSupplierItem{
            id
            designation
            description
            quantity
            unityId
            discount
            unitPrice
            total
            unity {id, name, code}
            }
            
      }
    }
  `

export default query;